import axios from "axios";

class API {
  constructor() {
    axios.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    axios.defaults.crossDomain = true;
  }

  serialize(obj) {
    let str = [];
    for (let p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }

  getClient(params) {
    return axios({
      method: "get",
      url: params.namespace + "/api/chat/chat.asmx/dados_user",
      headers: {
        chatRef: params.chatRef,
        user_id: params.authId,
        categoria: params.cat
      }
    });
  }

  getClients(params) {
    return axios({
      method: "get",
      url: params.namespace + "/api/chat/chat.asmx/participantes",
      headers: {
        chatRef: params.chatRef,
        sala_id: params.salaId
      }
    });
  }

  setClient(params, data) {
    return axios({
      method: "post",
      url: params.namespace + "/api/chat/chat.asmx/incluir_participante",
      headers: {
        chatRef: params.chatRef
      },
      data: this.serialize(data)
    });
  }

  getMessages(params) {
    return axios({
      method: "get",
      url: params.namespace + "/api/chat/chat.asmx/mensagens",
      headers: {
        chatRef: params.chatRef,
        sala_id: params.salaId
      }
    });
  }

  setMessage(params, data) {
    return axios({
      method: "post",
      url: params.namespace + "/api/chat/chat.asmx/incluir_mensagem",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        chatRef: params.chatRef,
        sala_id: params.salaId
      },
      data: this.serialize(data)
    });
  }

  getVideo(params) {
    return axios({
      method: "get",
      url: params.namespace + "/api/chat/chat.asmx/video",
      headers: {
        sala_id: params.salaId,
        chatRef: params.chatRef
      }
    });
  }
}

export default new API();


// WEBPACK FOOTER //
// ./src/chat/API.js